module.exports = __webpack_public_path__ + "media/images/icons/flags/UY-3e40bdde90fa718e07a7edb9bcbc6ffe.svg";